/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
  feather: {
    width: 32,
    height: 32,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M20.24 12.24a6 6 0 00-8.49-8.49L5 10.5V19h8.5zM16 8L2 22M17.5 15H9"/>',
  },
});
